"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormulaVariables = void 0;
var FormulaVariables;
exports.FormulaVariables = FormulaVariables;
(function (FormulaVariables) {
  FormulaVariables["Filter"] = "#";
  FormulaVariables["Property"] = "$";
  FormulaVariables["Table"] = "@";
  FormulaVariables["value"] = "~";
})(FormulaVariables || (exports.FormulaVariables = FormulaVariables = {}));